export { CompanyPage as default } from '@/components/enpages/Company'
